import { useQuery } from "@tanstack/react-query";
import { useClient } from "./useClient";
import { useEnvContext } from "../contexts/env-context";

export function usePhotoStores(loadConnectionInfo = true): {
	data: eXpress.core.IPhotoStore[] | undefined;
	isPending: boolean;
	refetch: () => Promise<eXpress.core.IPhotoStore[]>;
} {
	const client = useClient();
	const { account, language, pointOfSaleId } = useEnvContext();
	const accountId = account?.id;
	const hasAccount = eXpress.AccountId.isNotEmpty(accountId);

	const photoStoresResult = useQuery({
		queryFn: () => client.getPhotoStoresAsync(),
		queryKey: ["photoStores", language, pointOfSaleId],
		enabled: hasAccount,
	});

	const connectedPhotoStoresResults = useQuery({
		queryFn: () => client.getConnectedPhotoStoresAsync(),
		queryKey: ["connectedPhotoStores", accountId, language, pointOfSaleId],
		enabled: hasAccount && loadConnectionInfo,
	});

	const refetch = async () => {
		if (!hasAccount || !loadConnectionInfo) {
			return connectedPhotoStoresResults.data ?? [];
		}
		const result = await connectedPhotoStoresResults.refetch();
		return result.data ?? [];
	};

	if (!hasAccount) {
		return {
			isPending: false,
			data: [],
			refetch,
		};
	}
	const { isSuccess } = connectedPhotoStoresResults;
	const currentResult = isSuccess ? connectedPhotoStoresResults : photoStoresResult;
	return { ...currentResult, refetch };
}
